import * as api from '../api/specificationsApi';
import * as types from '../constants/specificationsConstants';
import { toast } from 'react-toastify';

export const getSpecificationsActions = () => async (dispatch) => {
  dispatch({ type: types.GET_SPECIFICATIONS_REQUEST });
  try {
    const { error, data } = await api.getSpecifications();
    if (error) {
      throw new Error(error);
    }
    dispatch({
      type: types.GET_SPECIFICATIONS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({ type: types.GET_SPECIFICATIONS_FAILURE });
    toast.error(error?.message ? error.message : 'Не вдалося завантажити специфікації авто');
  }
};

export const clearSpecificationsAction = () => async (dispatch) => {
  dispatch({ type: types.CLEAR_SPECIFICATIONS });
};
